import { useEffect } from 'react';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { getSupplierPaymentsReportJson } from '../../../../../redux/services/paymentsService';
import { useAppDispatch, useAppSelector } from '../../../../../redux/store';
import { PaymentRow, InvoicePaymentRow } from './types';

export const usePaymentsData = (dateRange: { startDate?: Date; endDate?: Date }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const { loadingList, paymentsReportData } = useAppSelector((state) => state.payments);

  const isLoading = loadingList.includes('getSupplierPaymentsReportJson');
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const validTimezone = momentTz.tz.zone(timezone) ? timezone : 'America/Los_Angeles';

  useEffect(() => {
    if (!currentSupplier?.id || !dateRange.startDate || !dateRange.endDate) return;

    dispatch(
      getSupplierPaymentsReportJson({
        supplierId: currentSupplier.id,
        startDate: moment(dateRange.startDate).format('MMM DD, YYYY'),
        endDate: moment(dateRange.endDate).format('MMM DD, YYYY'),
        timezone: validTimezone,
      })
    );
  }, [dateRange.startDate, dateRange.endDate, currentSupplier?.id, dispatch, validTimezone]);

  const payments: PaymentRow[] = paymentsReportData?.payments || [];
  const invoicePayments: InvoicePaymentRow[] = paymentsReportData?.invoicePayments || [];

  return {
    payments,
    invoicePayments,
    isLoading,
  };
};
